import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/79692005-3c4a-4727-a408-090d149a7cc9";
export const REGISTER_URL = "https://a.ntrk2.com/2325ae8a-f5da-4e15-a65e-06ede2350f21";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://popwin.kzw2a.com/download?openExternalBrowser=1&id=r94xpxa79o1xlg0";
